import { useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { SearchSection_SYS1010_R01 } from "src/containers/mes/SYS/SYS1010_R01/SearchSection_SYS1010_R01";
import { useSYS1010_R01Store } from "src/containers/mes/SYS/SYS1010_R01/Store_SYS1010_R01";
import { Table_SYS1010_R01 } from "src/containers/mes/SYS/SYS1010_R01/Table_SYS1010_R01";
import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";
import { getSYS1010_R01MinorCodeList } from "./Api_SYS1010_R01";
import { Content_SYS1010_R01 } from "./Content_SYS1010_R01";
import { defaultSYS1010_R01Dto, SYS1010_R01Dto } from "./Dto_SYS1010_R01";
import { DetailTable_SYS1010_R01 } from "./DetailTable_SYS1010_R01";
import { AgGridReact } from "ag-grid-react";

// 공통코드 관리 컨테이너 컴포넌트
export const Container_SYS1010_R01 = () => {
	
	const {
		majorSYS1010_R01List,
		selectedMajorSYS1010_R01,
		minorSYS1010_R01List, setMinorSYS1010_R01List, selectedMinorSYS1010_R01List, insertMinorSYS1010_R01List,
		setOriginalMinorSYS1010_R01List,
		allCount,
		initData,
	} = useSYS1010_R01Store();

	const { setCommonCodeModalVisible, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'SYS1010_R01',
		type: 'height',
		storageKey: 'SYS1010_R01-split-height',
		min: 5,
		max: 80,
		default: 50
	} as const;

	const gridRef = useRef<AgGridReact<SYS1010_R01Dto> | null>(null);
	const detailGridRef = useRef<AgGridReact<SYS1010_R01Dto> | null>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	// 마우스 이벤트 핸들러
	const {
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
	});

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: true,
		save: true,
		print: true,
		excel: false, // 엑셀 버튼은 항상 활성화
		init: false
	});

	// 선택된 메이저 코드와 마이너 코드 리스트가 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		// console.log("selectedMajorCode", selectedMajorCode);
		// console.log("minorCodeList", minorCodeList);
		setButtonDisabled(prev => ({
			...prev,
			delete: !selectedMajorSYS1010_R01 || minorSYS1010_R01List.length === 0,
			save: !selectedMajorSYS1010_R01 || minorSYS1010_R01List.length === 0,
			print: !selectedMajorSYS1010_R01,
			excel: false // 엑셀 버튼은 항상 활성화 (전체 공통코드 또는 상세코드 다운로드 가능)
		}));
	}, [selectedMajorSYS1010_R01, selectedMinorSYS1010_R01List, minorSYS1010_R01List]);

	

	const {
		handleExcelClick,
		handleCodeInputChange,
		defaultSYS1010_R01HeaderRow,
		defaultSYS1010_R01DetailRow,
		fetchData,
		initContainerData,
		handleDeleteClick,
		handleSaveClick,
	} = Content_SYS1010_R01({
		gridRef,
		detailGridRef,
		setMessage,
		
	});

	// 렌더링
	return <div className="content-container">
		{/* 액션바 */}
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {
				setCommonCodeModalVisible(true);
			}}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		{/* 검색 영역 */}
		<SearchSection_SYS1010_R01 onEnterKeyDown={fetchData} />
		{/* 메인 컨텐츠 영역 */}
		<div className="flex flex-col flex-1 px-[12px] gap-[4px] p-[10px]" ref={containerRef}>
			{/* 상단 테이블 */}
			<div className="w-full" style={{ height: `${splitValue}%` }}>
				<Table_SYS1010_R01 gridRef={gridRef} defaultSYS1010_R01HeaderRow={defaultSYS1010_R01HeaderRow()} />
			</div>
			{/* 리사이저 */}
			<div
				className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown("UD", e.nativeEvent)}
				onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
			/>
			{/* 하단 테이블 */}
			<div className="w-full" style={{ height: `${100 - splitValue}%` }}>
				<div className={`w-full h-full`}>
					<DetailTable_SYS1010_R01 data={minorSYS1010_R01List} gridRef={detailGridRef} defaultSYS1010_R01DetailRow={defaultSYS1010_R01DetailRow()}/>
				</div>
			</div>
		</div>
		{/* 메시지 */}
		<Message />
	</div>
}